import React from 'react';

import { Badge, Tab } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const TabBadge = ({ hasErrors, label, value, ...props }) => (
    <Tab
        {...props}
        label={
            <Badge
                color="error"
                content=""
                invisible={!hasErrors}
                variant="dot"
            >
                {label}
            </Badge>
        }
        value={value}
    />
);

TabBadge.propTypes = {
    hasErrors: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func,
    value: PropTypes.string,
};

export default TabBadge;
